<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">{{ crud }} Feature Flag</h4>
      </div>
      <div>
        <fg-input
          name="*company"
          label="Empresa">

          <el-select class=""
                      size="large"
                      style="width: 100%"
                      filterable
                      v-validate="modelValidations.company"
                      placeholder="Selecione a empresa"
                      v-model="company">
            <el-option v-for="option in companyList"
                        class=""
                        :value="option.profile__company__id"
                        :label="option.profile__company__name"
                        :key="option.id">
            </el-option>
          </el-select>
          <div class="text-danger invalid-feedback"
            ref="alertCompany"
            style="display: none; margin-top: -5px">Empresa é obrigatório</div>
        </fg-input>
        <fg-input
          name="type"
          label="Tipo">

          <el-select class=""
                      size="large"
                      style="width: 100%"
                      placeholder="Selecione o tipo de feature flag"
                      v-model="type">
            <el-option v-for="option in featureOpt.flag_type.choices"
                        class=""
                        :value="option.value"
                        :label="option.display_name"
                        :key="option.id">
            </el-option>
          </el-select>
        </fg-input>
        <fg-input
          v-if="showVM"
          name="vm"
          label="Vending Machine/Locker">

          <el-select class=""
                      size="large"
                      style="width: 100%"
                      placeholder="Selecione a VM/Locker"
                      v-model="vm">
            <el-option v-for="option in vmList"
                        class=""
                        :value="option.id"
                        :label="option.location"
                        :key="option.id">
            </el-option>
          </el-select>
        </fg-input> 
        <fg-input
        v-if="showFeature"
          name="feature_type"
          label="Feature">

          <el-select class=""
                      size="large"
                      style="width: 100%"
                      placeholder="Selecione a feature"
                      v-model="featureType">
            <el-option v-for="option in CompOrVend"
                        class=""
                        :value="option.value"
                        :label="option.display_name"
                        :key="option.id">
            </el-option>
          </el-select>
        </fg-input> 

          <fg-input name="active" label="Ativado">
            <div>
              <l-switch v-model="active"></l-switch>
            </div>
          </fg-input>
      </div>
    </card>
    <card>
      <div>
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info btn-wd">Salvar</button>
      </div>
    </card>
  </form>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { Switch as LSwitch } from "src/components/index";
import swal from "sweetalert2";
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Option.name]: Option,
    [Select.name]: Select,
    LSwitch
  },
  created() {
    this.getListCompany()
    if (this.$route.params.id) {
      this.crud = "Editar";
      this.initEdit()
    } else {
      this.crud = "Criar";
    }
  },
  mounted() {
    this.$store.dispatch('general/options').then(data =>{
      this.featureOpt = data.actions.POST
    })
    this.$watch('company',() => {
      this.vm = ''
      this.limit = 0
      this.getVM()
      this.$refs.alertCompany.style.display = 'none'
    })
    this.$watch('type',() => {
      this.showFeature = true
      if (this.type === 'V') {
        this.showVM = true
        if (this.crud === 'Editar') {
          this.vm = this.editVM
        }
      } else {
        this.showVM = false
      }
    })

    this.$watch('featureType',() => {
      if (this.featureType === 'V05') {
        this.remember()
      }
    })
  },
  computed: {
    CompOrVend () {
      var x 
      if (this.type === "V") {
      x = this.featureOpt.feature.choices.filter(v => {
        return v.value.charAt(0)  !== 'C'
      })
      }
      if (this.type === "C") {
      x = this.featureOpt.feature.choices.filter(v => {
        return v.value.charAt(0)  !== 'V'
      })
      }
      console.log('x' , x)
      return x
    },
  },
  data() {
    return {
      crud: "Editar",
      // imageKey: 0,
      model:{},
      active: true,
      showVM: false,
      showFeature: false,
      type: '',
      vm: '',
      featureType: '',
      editVM: '',
      featureOpt: [],
      limit: 0,
      vmList: [],
      company: '',
      users: [],
      pass: false,
      companyList: [],
      showUser: false,
      modelValidations: {
        company: {
          required: true
        },}
    };
  },
  methods: {
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    remember () {
      swal.fire({
        title: "Lembrete!",
        text: `Essa função só funcionará se esta mesma Vending Machine possuir a
         feature flag de Sincronização ativada!`,
        icon: "warning",
        showCancelButton: false,
        confirmButtonClass: "btn btn-success btn-fill",
        confirmButtonText: "OK",
        buttonsStyling: false
      })
    },
    initEdit () {
      this.$store.dispatch('general/flagGet', {id: this.$route.params.id}).then(data => {
        console.log('data editar', data)
        this.active = data.active
        this.company = data.company
        this.featureType = data.feature
        this.type = data.flag_type
        this.vm = data.vm
        this.editVM = data.vm
      })
    },
    getListCompany () {
      this.$store.dispatch('general/listUser').then(()=> {
        var x = this.$store.state.general.listUser.user_list_info
        this.companyList = x.filter((thing, index, self) =>
          index === self.findIndex((t) => (
            t.profile__company__id === thing.profile__company__id && t.profile__company__name === thing.profile__company__name
          ))
        )
      })
    },
    getVM () {
      this.$store.dispatch('machines/get', {id: '?company=' + this.company}).then(data =>{
        this.vmList = data
        console.log('this.vmlist', this.vmList )
        this.$store.dispatch('lockers/get',{id: '?company=' + this.company}).then(resp =>{
          for (let index = 0; index < resp.results.length; index++) {
            // if (this.limit == 0) {
              console.log('dentro', resp.results[index])
              this.vmList.push(resp.results[index])
            // }

            // this.limit += 1
          }
          console.log('this.vmlist222', this.vmList )
          if (this.type === 'V') {
            this.showVM = true
            if (this.crud === 'Editar') {
              this.vm = this.editVM
            }
          } else {
            this.showVM = false
          }
        })
        console.log('vmlin', this.vmList)
      })
    },
    validate() {
      this.model = {
        flag_type: this.type,
        feature: this.featureType,
        active: this.active,
        company: this.company,
        vm: this.vm
      }
      if (this.type === 'C') {
        this.model.vm = ''
      }
      if (this.model.company === '') {
        this.$refs.alertCompany.style.display = 'block'
      }
      this.$validator.validateAll().then(isValid => {
        if (isValid && this.crud === "Criar") {
          this.$store
            .dispatch("general/flagCreate", { item: this.model })
            .then(() => {
              this.notifySuccess();
              this.$router.push(`/app/featureflags`);
            });
        } else if (isValid && this.crud === "Editar") {
          this.model.id = this.$route.params.id 
          this.$store
            .dispatch("general/flagUpdate", { item: this.model })
            .then(() => {
              this.notifySuccess();
              this.$router.push(`/app/featureflags`);
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
